import React,{useEffect,useState,useMemo} from 'react';
import { Formik, Form } from 'formik';
import FormikControl from '../../../../components/FormikControls/FormikControl';
import DyButton from '../../../../components/GlobalComponents/DyButton/DyButton';
import { useSelector } from 'react-redux';
import {Tooltip} from '@mui/material';
import {CircularProgress} from '@mui/material';
import { Grid,Box,Typography,Divider} from '@mui/material';
import DyDataGrid from '../../../../components/GlobalComponents/DyDataGrid2/DyDataGrid';
import { ErrorMessage } from 'formik';
import DYToastMessage from "../../../../components/GlobalComponents/DyToastMessage/DYToastMessage";
import { useAddCommitmentsCheckinMeeting, useGetCommitMeetingHistory } from '../../Hooks';
import { nextStateActionOptions } from '../../StataicData';
import { passValidationSchema1 } from '../../../CompanyManagment/StaticData';

export const CreateCommitments = ({setShowToastMessage1,text,coomitId,objective,afterAddKr,onSuccess,kkk}:any) => {
  const meetSelectedDate = useSelector((state: any) => state.meetings.meetSelectedDate);
    const meetingId: any = useSelector((state: any) => state.meetings.meetingId);
    const profileTenantId: any = useSelector((state: any) => state.meetings.profileTenantId);
    const [showToastMessage, setShowToastMessage] = useState<any>(false);
    const [showToastMessageResult, setShowToastMessageResult] = useState<any>('');
    const {data:historyData,isLoading:historyDataLoading}:any=useGetCommitMeetingHistory(meetingId,coomitId);
    const { mutate: addCheck, isSuccess,isLoading:AddChekinLoading,data:addCheckingData } = useAddCommitmentsCheckinMeeting();
    
    const evaluationData: any = {
      newDate: '',
      commitmentsStatus: '',
      progressPercentage: '',
      newTime: '',
      objectId: kkk,
      id: coomitId,
      description: '',
    }
  const initialSubmitForm: any = (data: any): any => {
    data.teamId = objective?.teamId;
    data.meetingId = meetingId;
    data.tenantId = profileTenantId;
    addCheck(data);
  }

  const KRHColumns: any = useMemo(()=>
  [
    {
      field: "rowid",
      headerName: "ردیف",
      width: 35,
      sortable: false,
      align:'center',
      headerAlign:'center',
      renderCell: (params:any) => params.api.getAllRowIds().indexOf(params.id)+1
    }
    ,
    { field: 'meetingDate',
         headerName: 'تاریخ جلسه',
         sortable:false,
         headerAlign:'center',
         align:'center',
          width: 100,
          }
          ,
        { field: 'progressPercentage',
        headerName: 'درصد پیشرفت',
        align:'center',
        sortable:false,
        headerAlign:'center',
         width: 150,
         renderCell:({value}:any)=>{
          if (value!==null) {
            return <Box>
            {
             value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
             {value}
           </Tooltip>:
           <Typography  sx={{fontSize:'12px'}} >{value}</Typography>
            }
           </Box>
          }
          else {
            return null
          }
        }         
         }
         ,
         { field: 'newDate',
       headerName: 'تاریخ جدید ',
       align:'center',
       sortable:false,
       headerAlign:'center',
        minWidth: 120 ,
      }
          ,
      { field: 'newTime',
       align:'center',
       headerName: 'زمان جدید',
       headerAlign:'center',
       sortable:false,
       wrap:'wrap',
        minWidth: 130,
        fontsize:'12px !important',
  }
  ,
  {
    field: 'description',
    headerName: 'توضیحات',
    align: 'center',
    headerAlign: 'center',
    sortable: false,
    minWidth: 110,
    renderCell:({value}:any)=>{
      return <Box>
       {
        value.length>10? <Tooltip  sx={{fontSize:'1.5rem !important'}} title={value}>
        {value}
      </Tooltip>:
      <Typography  sx={{fontSize:'12px'}} >{value}</Typography>
       }
      </Box>
    }
  }
    ],[]);

    const formatValue = (value: number) => {
      return value < 0 ? `${Math.abs(value)}-` : `${value}`;
     };
  
    useEffect(() => {
    if (addCheckingData) {
      if (addCheckingData?.data.isSuccess) {
         setShowToastMessage1(true)
         setShowToastMessage1(addCheckingData?.data.metaData.message);
         onSuccess(false)
      } else {
        setShowToastMessageResult(addCheckingData?.data.metaData.message);
        setShowToastMessage(true);
      }   
  }
    }, [addCheckingData])

  return (
    <Grid container  >
    <Grid item xs={12}  >
    <Box width={'100%'} 
    minHeight={'20px'} 
    borderRadius={2} 
    sx={{display:'flex',flexWrap:'wrap',justifyContent:'space-between',alignItems:'center'}}
    >
    <Box sx={{width:'40%',minHeight:'100px',display:'flex',flexDirection:'column',p:1,rowGap:1}}>
    {/* <Box  display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >هدف:</Typography> <Typography variant='caption'  >{name}</Typography>  </Box> */}
    {/* <Divider /> */}
    <Box  display={'flex'} columnGap={1} justifyContent={'start'} >
      <Typography variant='body2' fontWeight={700} >ارزیابی تعهد:</Typography> 
      <Typography variant='caption'>{text}</Typography></Box>
    <Divider />
    {/* <Box  display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >مسئول:</Typography> <Typography variant='caption'>{responsibleName}</Typography>  </Box> */}
    {/* <Divider /> */}
 
    </Box>
    {/* <Box  sx={{width:'35%',minHeight:'100px',display:'flex',flexDirection:'column',p:1,rowGap:1}}>
   
    <Box  display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >مقدار شروع:</Typography> <Typography variant='caption'  >{startValue}</Typography>  </Box>
    <Divider />

    
    <Box  display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >سطح 30%:</Typography> <Typography variant='caption'  >{threeTenthsValue}</Typography>  </Box>
    <Divider />

    <Box  display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  > سطح 70%:</Typography> <Typography variant='caption'  >{sevenTenthsValue}</Typography>  </Box>
    <Divider />

    <Box display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >  سطح 100%:</Typography> <Typography variant='caption'  >{oneValue}</Typography>  </Box>
  
    </Box> */}
<Box sx={{ width: '35%', minHeight: '100px', display: 'flex', flexDirection: 'column', p: 1, rowGap: 1 }}>
<Box  display={'flex'} columnGap={1} justifyContent={'start'} ><Typography variant='body2' fontWeight={700}  >تاریخ جلسه:</Typography> <Typography variant='caption'>{meetSelectedDate}</Typography>  </Box>
    <Divider />

    {/* <Box display={'flex'} columnGap={1} justifyContent={'start'}>
        <Typography variant='body2' fontWeight={700}>سطح 30%:</Typography>
        <Typography variant='caption'>{formatValue(threeTenthsValue)}</Typography>
    </Box>
    <Divider />

    <Box display={'flex'} columnGap={1} justifyContent={'start'}>
        <Typography variant='body2' fontWeight={700}>سطح 70%:</Typography>
        <Typography variant='caption'>{formatValue(sevenTenthsValue)}</Typography>
    </Box>
    <Divider />

    <Box display={'flex'} columnGap={1} justifyContent={'start'}>
        <Typography variant='body2' fontWeight={700}>سطح 100%:</Typography>
        <Typography variant='caption'>{formatValue(oneValue)}</Typography>
    </Box> */}
</Box>
    {/* <Box sx={{width:'15%',minHeight:'100px'}}>
    <DyLinearProgress 
    value={progressFormValues?.score}
    // progressFormValues?.score
    mainLabel={'آخرین درصد تحقق نتیجه'}
     />
      <DyLinearProgress 
    value={progressFormValues?.assessmentRate}
    mainLabel={'میزان ارزیابی'}
     />
    </Box> */}
    </Box>
    </Grid>

    <Grid  item xs={12} >
    {
      historyDataLoading && <Grid container  >
       <Box width={'100%'} py={5} textAlign={'center'} >
        <CircularProgress color='primary'   />
       </Box>
      </Grid>
    }
    {
       historyData && <Grid  container >
       <Grid item xs={12} mx={'auto'} sx={{bgcolor:'#F9F9F9'}}  >
       <Formik
              validationSchema={passValidationSchema1}
               enableReinitialize
               initialValues={evaluationData }
               onSubmit={(data: any) => {
                 initialSubmitForm(data)
               }}
               validate={(data)=>{
               }}
             >
               {
                 ({ values, setFieldValue, dirty, isValid, touched, errors, setFieldTouched }:any) => 
                   <Form>
                     {
                       true && 
                       <Grid container columnSpacing={1} sx={{bgcolor:'#F9F9F9',mx:'auto',borderRadius:3}}>    
                      <Grid item xs={12} md={3} >
                      <div className='error'>
                      <ErrorMessage name="newValue" />
                      </div>
                         <FormikControl
                           control='textField'
                          //  type='text'
                           label='درصد پیشرفت'
                           name='progressPercentage'
                          //  fullWidth
                          //  value={values?.newValue || ''}
                          value={values?.progressPercentage || ''}
                          //  description={'hi'}
                          //  helperText='kjkj'
                          //  errors={errors}
                          //  type={pointSystemsL==="مرحله ای"?'text':'number'}
                         />
                       </Grid>
                        
                       <Grid item xs={12} md={3} >
                      <FormikControl
                        control='select'
                        type='select'
                        label='وضعیت'
                        options={nextStateActionOptions}
                        name='commitmentsStatus'
                        fullWidth
                        value={values?.commitmentsStatus || ''}
                      />
                    </Grid>
                    <Grid item xs={12} md={3} >
                      <FormikControl
                        control='date'
                        type='date'
                        label='تاریخ جدید'
                        name='newDate'
                        fullWidth
                        value={values?.startDate || ''}
                      />
                    </Grid>

                    <Grid item xs={12} md={3}>
                      <FormikControl
                        control="timePicker"
                        name="newTime"
                        label="زمان جدید"
                        value={values.startTime}
                      />
                    </Grid>

                       <Grid item xs={12} md={12}  >
                         <FormikControl
                           control='textField'
                           type='text'
                           label='توضیحات'
                           name='description'
                           fullWidth
                           value={values?.description || ''}
                           placeholder={'توضیحات (اختیاری)  0/300'}
                         />
                       </Grid>

                        {/* <Grid item xs={12} md={2} >
                       <Box width={'100%'} textAlign={'center'} py={1} >
                       <AssessorCommitments 
                        setSelectedInitialValue={setSelectedInitialValue}
                        optionList={assessmentHistory} 
                        />
                       </Box>
                       </Grid> */}

                       <Grid item xs={12}   >
                          <DyDataGrid
                          columns={KRHColumns || []}
                          data={historyData||[]}
                          setRowSelectedData={()=>{}}
                          hideFooter={true}
                          setSelectionModel={()=>{}}
                          selectionModel={''}
                          additionalToolbar={false}
                          drName={'hisTable'}
                          initialOnRowClick={()=>{}}
                          withoutOptions={true}
                          />
                      </Grid>

                       <Grid item xs={12}  >
                         <Box   columnGap={2} display={'flex'} flexDirection={'row-reverse'}  >
                           <Box >
                             <DyButton
                               caption={'ذخیره'}
                               color={'#00387C'}
                               onClick={() => { }}
                               variant={'contained'}
                               bgColor={'#00387C'}
                               type={'submit'}
                             />
                           </Box>
                           {/* <Box>
                             <DyButton
                               caption={'انصراف'}
                               // color={'#00387C'}
                               // onClick={loginHandler}
                               disbled={false}
                               variant={'outlined'}
                               onClick={initialCancel}
                             />
                           </Box> */}
                         </Box>
                       </Grid>
                     </Grid>
                     }
                   </Form>
               }
             </Formik>
       </Grid>
        </Grid>
    }
     <Box marginTop={3}> </Box>
    </Grid>
    {setShowToastMessage && (
          <DYToastMessage
            isSuccess={addCheckingData?.data.isSuccess}
            message={showToastMessageResult}
            setShow={setShowToastMessage}
            show={showToastMessage}
          />
        )}
         
    </Grid>
  )
}
